import React, { useState, useEffect } from "react";

// components imports
import SelectElement from "../../components/common/SelectElement";
import CreatePapersPatternButton from "../../pages/ReactDocx";
import CreateArchivePatternButton from "../../pages/ReactDocxArchive";
import NavigationBar from "../../components/common/NavigationBar";

// scss imports
import css from "./DocumentPatterns.module.scss";

// redux
import { getAllPagePapers } from "../../redux/actions/papersActions";
import {
  getArchiveOfCurrentUser,
  getArchiveForWord
} from "../../redux/actions/archiveActions";

import { useSelector, useDispatch } from "react-redux";

interface DocumentPatternsProps {}

const DocumentPatterns: React.FC<DocumentPatternsProps> = ({}) => {
  const dispatch = useDispatch();

  // all papers for selected year
  const allPagePapers = useSelector((state: any) => state.papers.allPagePapers);
  const [allPapersYear, setAllPapersYear] = useState<any>();

  const [allPapersForPrinting, setAllPapersForPrinting] = useState();

  const [selectOptionsAllYears, setSelectOptionsAllYears] = useState<any>([
    { name: "Изабери годину", value: "" }
  ]);

  const [papersListCreated, setPapersListCreated] = useState(true);
  let FIXED_YEAR = 2018;
  const currentYear = new Date().getFullYear();

  const getSelectOptions = () => {
    for (let i = FIXED_YEAR; i <= currentYear; i++) {
      setSelectOptionsYears((oldArray) => [
        ...oldArray,
        { name: `${i} година`, value: i }
      ]);
    }
  };

  // Archive
  // all archived documents for selected year
  const currentYearArchiveArr = useSelector(
    (state: any) => state.archive.allArchive
  );
  const [papersYear, setPapersYear] = useState<any>();

  const [archivedDocumentsForPrinting, setArchivedDocumentsForPrinting] =
    useState();

  const [selectOptionsYears, setSelectOptionsYears] = useState<any>([
    { name: "Изабери годину", value: "" }
  ]);
  const [selectedArchiveYear, setSelectedArchiveYear] = useState(true);

  /*useEffect(() => {
    setPapersForPrinting(allPagePapers);
  }, [allPagePapers]);*/

  useEffect(() => {
    setSelectOptionsYears([{ name: "Изабери годину", value: "" }]);
    getSelectOptions();
    dispatch(getArchiveForWord());
  }, []);

  // papers
  const onSelectAllPapersChange = (e, setValue) => {
    setValue(e.target.value);
    setPapersListCreated(false);
    const select = document.getElementsByTagName("select")[0];
    setAllPapersYear(select.value);
  };

  useEffect(() => {
    dispatch(getAllPagePapers("", "", `&createdAtYear=${allPapersYear}`));
  }, [allPapersYear]);

  useEffect(() => {
    setAllPapersForPrinting(allPagePapers);
  }, [allPagePapers]);

  // archive
  const onSelectChange = (e, setValue) => {
    setValue(e.target.value);
    setSelectedArchiveYear(false);
    const select = document.getElementsByTagName("select")[1];
    setPapersYear(select.value);
  };

  useEffect(() => {
    dispatch(getArchiveOfCurrentUser("", "", `&createdAtYear=${papersYear}`));
  }, [papersYear]);

  useEffect(() => {
    setArchivedDocumentsForPrinting(currentYearArchiveArr);
  }, [currentYearArchiveArr]);

  return (
    <div>
      <NavigationBar />
      <div className={css.container}>
        <div className={css.childDiv}>
          <p>Изаберите годину за коју желите да штампате деловодник</p>
          <div className={css.selectElementWrapper}>
            <div
              onClick={() => {
                const select = document.getElementsByTagName("select")[0];
                setAllPapersYear(select.value);
              }}
            >
              <SelectElement
                label=""
                id="category"
                name="category"
                handleChange={(e) =>
                  onSelectAllPapersChange(e, setAllPapersYear)
                }
                selectOptionsArray={
                  selectOptionsYears ? selectOptionsYears : []
                }
              />
            </div>
          </div>
          <CreatePapersPatternButton
            allPagePapers={allPagePapers}
            disabled={papersListCreated}
            allPapersYear={allPapersYear}
          />
        </div>
        <div className={css.childDiv}>
          <p>Штампај архивску књигу</p>
          {/*<div className={css.selectElementWrapper}>
						<SelectElement
							label=""
							id="archive"
							name="archive"
							handleChange={(e) => onSelectChange(e, setPapersYear)}
							selectOptionsArray={selectOptionsYears ? selectOptionsYears : []}
						/>
							</div>*/}
          <div
          /*onClick={() => {
              const select = document.getElementsByTagName("select")[1];
              setPapersYear(select.value);
            }}*/
          >
            <CreateArchivePatternButton
              archivedDocumentsForPrinting={archivedDocumentsForPrinting}
              disabled={selectedArchiveYear}
              papersYear={papersYear}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentPatterns;
